"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _usePlugins = require("./usePlugins");
Object.keys(_usePlugins).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePlugins[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _usePlugins[key];
    }
  });
});
//# sourceMappingURL=index.js.map